import React from 'react';
import propTypes from 'prop-types';

const Checkbox = ({
  id,
  label,
  size = '',
  ...htmlProps
}) => (
  <div className={`cmp-checkbox ${size ? `cmp-checkbox--${size}` : ''}`}>
    <input
      type="checkbox"
      id={id}
      className="cmp-checkbox__input"
      {...htmlProps}
    />
    <label
      htmlFor={id}
      className="cmp-checkbox__label"
    >
      {label}
    </label>
  </div>
);

Checkbox.propTypes = {
  id: propTypes.string,
  label: propTypes.string,
  size: propTypes.string,
};

export { Checkbox };
